module.exports = __webpack_public_path__ + "img/icon_jh.d0289dc0.png";